export default "__VITE_ASSET__DSyBgHQ8__"